<mat-card appearance="outlined" [formGroup]="formGroup" arial-label="Card-NotificationHistoryChart-UtilityBilling">
    <mat-card-header fxLayout="row" fxLayoutAlign="space-between start">
        <lgd-select fxFlex="80" controlName="notificationType" label="Notification History"
                    [options]="notificationTypesObservable">
        </lgd-select>
        <forge-icon-button class="chart-settings" (click)="displayChartParameterDialogAndReload()" tabindex="0"
                           aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </mat-card-header>

    <mat-card-content>
        <div *ngIf="isLoaded">
            <chartjs-container *ngIf="showChart" [config]="chartConfig">
            </chartjs-container>


            <div *ngIf="!chartHasData">
                Not enough data to display graph
            </div>

            <div *ngIf="errorMessage" class="error-red">
                {{errorMessage}}
            </div>
        </div>

        <busy-indicator *ngIf="!isLoaded" [chart]="true"></busy-indicator>
    </mat-card-content>
</mat-card>
